import { Box, Typography } from "@mui/material"
import { If } from "lib/@components/switch"

export function PdfReferencesListItem({ item }) {
    return (
        <Box sx={{ mb: "10px" }}>
            <Typography
                sx={{
                    display: "inline",
                    fontSize: "10px",
                    fontWeight: item.status === "unchanged" ? 400 : 700,
                    color: getReferenceColor(item.status),
                    bgcolor: getReferenceBackground(item.status),
                    px: item.status === "unchanged" ? 0 : "2px",
                    textDecoration: item.status === "removed" ? "line-through" : "none",
                }}
            >
                {item.title}
            </Typography>
            <If value={item.status !== "unchanged"}>
                <Typography sx={{ fontSize: "10px", color: getReferenceColor(item.status), mt: "2px" }}>
                    {item.status === "removed" ? "Removed" : "New Reference"}
                </Typography>
            </If>
        </Box>
    )

    function getReferenceBackground(status) {
        if (status === "removed") return "rgba(243, 198, 198, 0.9)"
        if (status === "added") return "rgba(199, 226, 252, 0.95)"
        return "transparent"
    }

    function getReferenceColor(status) {
        if (status === "removed") return "#9b2c2c"
        if (status === "added") return "#215f9a"
        return "#1f2937"
    }
}
